import { Image } from '@chakra-ui/react'

import WatermarkImage from '../../assets/map/tl-watermark.png'


export default function MapWatermark() {
    return (
        <>
            <Image 
                src={WatermarkImage}
                style={{
                    position: 'absolute', 
                    marginTop: '3px', 
                    marginLeft: '3px', 
                    zIndex: 500, 
                    height: '50px', 
                    width: '187.5px' 
                }}
            />
        </>
    )
}